import React from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import Fade from 'embla-carousel-fade'
import Autoplay from 'embla-carousel-autoplay'
import { DotButton, useDotButton } from './EmblaCarouselDotButton'
import { Heading } from '../../ui/heading/Heading'
import { Button } from '../../ui/button/Button'
import { MarkupLayout } from '../../ui/markupLayout/MarkupLayout'
import styles from "./mainBackgroundSlider.module.css"
import { Carousel } from '../../carousel/Carousel'
export function MainBackgroundSlider() {
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true, duration: 30, watchDrag: false, }, [Fade(), Autoplay({ delay: 500000, active: true })])
    const slides_s = [
        {
            id: 1,
            name: "filtr",
            heading: "Автомобильные фильтры",
            description: ["Фильтры на более 90% автомобилей мирового рынка"],
            img: "/images/item_filter.webp",
            backGroundImg: "/images/car.webp"
        },
        {
            id: 2,
            name: "brake",
            heading: "Тормозные колодки",
            description: ["Уникальный состав", "Европейская сертификация"],
            img: "/images/item_brake.jpg",
            backGroundImg: "/images/brake.webp"
        },
        {
            id: 3,
            name: "wippers",
            heading: "Щетки стеклоочистителя",
            description: ["Щётки с покрытием парка автомобилей более чем на 95%"],
            img: "/images/item_wippers.webp",
            backGroundImg: "/images/wipers.webp"
        },
        {
            id: 4,
            name: "brake",
            heading: "Тормозные колодки",
            description: ["Уникальный состав", "Европейская сертификация"],
            img: "/images/item_brake.jpg",
            backGroundImg: "/images/brake.webp"
        },
        {
            id: 5,
            name: "wippers",
            heading: "Щетки стеклоочистителя",
            description: ["Щётки с покрытием парка автомобилей более чем на 95%"],
            img: "/images/item_wippers.webp",
            backGroundImg: "/images/wipers.webp"
        }
    ];

    const { selectedIndex, scrollSnaps, onDotButtonClick } =
        useDotButton(emblaApi)
    return (
        <>
            <section className={styles.carousel_section}>
                <div className={styles.embla}>
                    <div className={styles.embla__viewport} ref={emblaRef}>
                        <div className={styles.embla__container}>
                            {slides_s.map((item) => (
                                <div className={styles.embla__slide} key={item.id}>
                                    <picture className={styles.gradient}>
                                        <img loading='lazy' src={item.backGroundImg} className={styles.backGroundImg} alt={item.name} />
                                        {item.name === "filtr" ? <img loading='lazy' src='/images/carFront2.webp' className={styles.front_car} alt={item.name} /> : ""}
                                        <h1 className={styles.heading_holder__h1}>{item.heading}</h1>

                                        <div className={item.name === "filtr" ? "" : ""}>

                                            <MarkupLayout>
                                                <div className={styles.hero_holder}>
                                                    <div className={styles.heading_holder}>

                                                        {/* <p className={styles.heading_holder__info}>{item.description[0]}</p> */}

                                                        <ul className={styles.hero__list}>
                                                            {item.description.map((item, idx) => {
                                                                return <li className={styles.hero__list_item} key={item[idx]}><p>{item}</p></li>
                                                            })}
                                                        </ul>

                                                    </div>
                                                    <div className={styles.button_holder}>
                                                        <Button variant={"white"} width={"w-310"} behaviour={"link"} link={"/catalog"}>Каталог подбора</Button>
                                                        <div className={styles.embla__dots}>
                                                            {scrollSnaps.map((_, index) => (
                                                                <DotButton
                                                                    key={index}
                                                                    onClick={() => onDotButtonClick(index)}
                                                                    className={`${styles.embla__dot}${index === selectedIndex ? ` ${styles[`embla__dot--selected`]}` : ''}`}
                                                                />
                                                            ))}
                                                        </div>
                                                    </div>
                                                    <Heading>Автомобильные фильтры</Heading>
                                                </div>
                                                <img loading='lazy' className={styles.img} src={item.img} alt={item.heading} />
                                                <div className={`${styles[`stick__${item.name}`]}`}></div>
                                            </MarkupLayout>
                                        </div>
                                    </picture>
                                </div>

                            ))}
                        </div>

                    </div>
                </div>
            </section>
            <Carousel />
        </>
    )
}
